/**
 * Every picture in a Build conversation, in the order they appear (eddy,
 * 2026-10-27): the images the person put in their messages and the images the
 * Builder created (screenshots, image files). Clicking any thumbnail opens the
 * large view on that picture; previous and next step through this list.
 *
 * Pure, so the order and the wrap-around are tested without a browser.
 */

import type { TranscriptItem } from './coding-events';
import { fileViewKind, projectFileUrl } from '~/features/windows/file-view';

export interface ConversationImage {
  src: string;
  name: string;
}

const MESSAGE_IMAGE = /!\[([^\]\n]*)\]\((\/api\/files\/[^)\s]+\/raw)\)/g;

export function conversationImages(
  items: readonly TranscriptItem[],
  creations: ReadonlyMap<number, string>,
  sessionId: string | null,
): ConversationImage[] {
  const out: ConversationImage[] = [];
  const seen = new Set<string>();
  const add = (src: string, name: string) => {
    if (seen.has(src)) return;
    seen.add(src);
    out.push({ src, name });
  };
  for (const item of items) {
    if (item.kind === 'user') {
      for (const m of item.text.matchAll(MESSAGE_IMAGE)) add(m[2], m[1] || 'Image');
      continue;
    }
    const path = creations.get(item.seq);
    if (sessionId && path && fileViewKind(path) === 'image') add(projectFileUrl(sessionId, path), path.split('/').pop() || path);
  }
  return out;
}

/** The index `delta` steps from `index`, wrapping at both ends. */
export function stepIndex(index: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  return (((index + delta) % count) + count) % count;
}
